"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTimeLogger = exports.mongoDBLogger = void 0;
const labeledJSONLogger_1 = require("./logger/labeledJSONLogger");
exports.mongoDBLogger = (0, labeledJSONLogger_1.createLabeledJSONLogger)('MONGODB_QUERIES');
exports.requestTimeLogger = (0, labeledJSONLogger_1.createLabeledJSONLogger)('REQUEST_TIME');
